import req from "../http";

const department = {
  // 取得 部門
  getDepartment(params) {
    return req("get", "/BasicInformation/department", params);
  },

  // 新增 部門
  postDepartment(params) {
    return req("post", "/BasicInformation/department", params);
  },

  // 更新 部門
  putDepartment(params) {
    return req("put", "/BasicInformation/department", params);
  },

  // 刪除 部門
  deleteDepartment(params, guid) {
    return req("delete", `/BasicInformation/department/${guid}`, params);
  },

  // 下載 組織範本
  departmentTemplateDownload() {
    return req("get", "/BasicInformation/DepartmentTemplateDownload", null, { responseType: "blob" });
  },

  // 上傳 組織結構
  uploadOrgStructure(params) {
    return req("post", "/BasicInformation/Upload", params, { headers: { "Content-Type": "multipart/form-data" } });
  }
};

export default department;